import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ViewToolbarProps {
    children: ReactNode
    className?: string
}

export function ViewToolbar({ children, className }: ViewToolbarProps) {
    return (
        <div className={cn('flex shrink-0 flex-wrap items-center justify-between gap-2 px-4 py-4', className)}>
            {children}
        </div>
    )
}

interface EmptyStateProps {
    title: string
    description?: string
    action?: ReactNode
    className?: string
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
    return (
        <div className={cn('flex flex-col items-center gap-2 px-6 py-14 text-center', className)}>
            <span className='lead-style block font-medium'>
                {title}
            </span>
            {description && (
                <span className='caption-style text-subtle block max-w-[32em] leading-[1.4]'>
                    {description}
                </span>
            )}
            {action && <div className='mt-2'>{action}</div>}
        </div>
    )
}

interface SectionHeadingProps {
    title: string
    count?: number
    action?: ReactNode
}

export function SectionHeading({ title, count, action }: SectionHeadingProps) {
    return (
        <div className='flex items-center justify-between gap-2'>
            <h2 className='eyebrow-style text-soft flex items-center gap-2 font-normal'>
                {title}
                {count !== undefined && (
                    <span className='text-subtle tracking-normal'>
                        {count}
                    </span>
                )}
            </h2>
            {action}
        </div>
    )
}
